"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = styles_1.makeStyles((theme) => ({
    button: {
        background: theme.palette.common.white,
        borderRadius: '50px',
        color: '#0057B8',
        fontSize: '0.875em',
        height: '48px',
        maxWidth: '289px',
        minWidth: '56px',
        '&:hover': {
            background: theme.palette.grey[100],
        },
    },
    buttonsContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        height: '100%',
        justifyContent: 'center',
        marginBottom: theme.spacing(4),
        maxWidth: '289px',
        width: '100%',
    },
    contentContainer: {
        background: theme.palette.common.white,
        marginTop: '50px',
        [`${theme.breakpoints.between('xs', 'sm')} and (orientation: landscape)`]: {
            marginBottom: '16px',
            marginTop: '16px',
        },
        width: '100%',
    },
    companyLogo: {
        [`${theme.breakpoints.between('xs', 'sm')} and (orientation: landscape)`]: {
            height: '20px',
        },
    },
    dialogContainer: {
        background: theme.palette.common.white,
        maxWidth: '337px',
        width: '337px',
        [`${theme.breakpoints.between('xs', 'sm')} and (orientation: landscape)`]: {
            maxWidth: '500px',
            width: '500px',
        },
    },
    errorMessageContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '& >.messageContainer': {
            display: 'flex',
            marginBottom: '40px',
            marginTop: '24px',
            '& >p': {
                fontWeight: 'normal',
            },
            [`${theme.breakpoints.between('xs', 'sm')} and (orientation: landscape)`]: {
                marginBottom: '16px',
                marginTop: '24px',
                '& >p': {
                    whiteSpace: 'normal',
                },
            },
        },
        '& >.svgContainer': {
            marginBottom: '50px',
            [`${theme.breakpoints.between('xs', 'sm')} and (orientation: landscape)`]: {
                display: 'none',
            },
        },
        width: '100%',
    },
    paper: {
        alignItems: 'center',
        borderRadius: '30px',
        display: 'flex',
        justifyContent: 'center',
        maxHeight: 'fit-content',
        maxWidth: 'fit-content',
        width: '100%',
    },
}));
